import { useLogin } from "@refinedev/core";
import React, { useEffect } from "react";
import { SyncrosaleLoader } from "../../components/layout/components/SyncrosaleLoader";

export const Login: React.FC = () => {
  const { mutate: login } = useLogin();

  useEffect(() => login({}), []);

  return <SyncrosaleLoader />;
};
